//import "./js/example.js";
import Alpine from 'alpinejs';
import "./js/global-paths.js";
import "./js/iodine-config.js";
import "./js/date-picker.js";
import "./js/datahub-helpers.js";
import "./js/flickity-pv-reinit.js";
import "./js/photoswipe-pv-reinit.js";
import "./js/link-freshchat.js";
import "./js/init-timify.js";
import "./js/scroll-hash-fix.js";

window.Alpine = Alpine;
Alpine.start();
